let increment;
import { SaveButton } from "./components/SaveButton";

export default {
    init() {
        this.initModal();
        this.initTable();
        this.addModifier();
        this.editModifier();
        this.deleteModifier();
        this.deleteModifierInRow();
        this.getFormItems();
        this.save('/modifiers', '.modifier-form');
        this.save('/modifier_save_items', '.modifier-form-items');

    },
    initModal() {
        $('.add-modifier-set').click(function () {
            increment = 1;
            $.ajax({
                type: 'GET',
                url: '/get_form_modifier',
                success: function (response) {
                    $('#modifier_form').html(response);
                    $('#modifier-modal').modal('show');
                }
            });
        });
    },
    initTable() {
        if ($('#modifier_table').length) {
            $('#modifier_table').ready(function () {
                $.ajax({
                    type: 'GET',
                    url: '/get_modifiers',
                    success: function (response) {
                        $('#modifier_table').html(response);
                        $('#modifier_table #table').DataTable({
                            ajax: {
                                type: 'GET',
                                url: '/get_modifiers_for_datatable',
                            },
                            columns: [
                                {'data': 'title'},
                                {'data': 'modifiers'},
                                {
                                    'data': 'Actions',
                                    render: function (data, type, row) {
                                        return '<div class="text-right">' +
                                            '<a href="#" class="btn apply-to-items modifier-add-items mr-3" data-id="' + row.id + '">Apply to items</a>' +
                                            '<a href="#" class="btn text-secondary modifier-delete" data-id="' + row.id + '"><i class="fa fa-lg fa-trash"></i></a>' +
                                            '<a href="#" class="btn text-secondary modifier-edit" data-id="' + row.id + '"><i class="fa fa-lg fa-pencil"></i></a>' +
                                            '</div>';
                                    }
                                }
                            ]
                        });
                    }
                });
            });
        }
    },
    save(url, $class) {
        $('body').on('click', $class + ' #modifier-submit-form', function (e) {
            this.SaveBtn = new SaveButton();
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: url,
                data: $('#modifier-form').serialize(),
                beforeSend: () =>{
                    this.SaveBtn.startLoading();
                },
                success: () => {
                    this.SaveBtn.stopLoading(true).then(
                        () => {
                            this.SaveBtn.showSuccess().then(
                                function() {
                                    $('#modifier-modal').modal('hide');
                                    $('#modifier_table #table').DataTable().ajax.reload(null, false);
                                })
                        }
                    );
                },
                error: function (response) {
                    this.SaveBtn.showError().then(
                        () => {
                            let errorsHtml = '<div class="alert alert-danger">';
                            if (response.responseJSON.error) {
                                errorsHtml += response.responseJSON.error;
                            }
                            if (response.responseJSON.errors) {
                                errorsHtml += 'Some errors occurred:<br /><ul>';

                                $.each(response.responseJSON.errors, function (index, value) {
                                    errorsHtml += '<li>' + value + '</li>';
                                });
                                errorsHtml += '</ul>';
                            }
                            errorsHtml += '</div>';
                            $('.modifier-form-wrapper .form-validation-errors').html(errorsHtml);
                        }
                    );
                }
            })
        });
    },
    addModifier() {
        let $this = this;
        $('body').on('click', '.add-modifier', function (e) {
            e.preventDefault();
            $this.getRowModifier();
        });
    },
    modifierSetTypeChange() {
        $('#modifier-type').change(function(){
            $('#modifiers').html('');
        });
    },
    modifierSetSortChange() {
        $('.modifier-edit-row__sort-arrows a').click(function(e){
            e.preventDefault();
            let currentArrow = $(this);
            let direction = currentArrow.data('direction');
            let currentElem = currentArrow.closest('.modifier-edit-row');
            let currentElemSort = currentElem.data('sort');
            if (direction == 'up')
                currentElemSort--;

            if (direction == 'down')
                currentElemSort++;

            let targetElement = $('div[data-sort="' + currentElemSort + '"]', '#modifiers');
            if (targetElement.length){
                let tagetInputs = $('input[type="text"]', targetElement);
                let currentInputs = $('input[type="text"]', currentElem);
                currentInputs.each(function(index, input){
                    let currentVal = $(input).val();
                    $(input).val($(tagetInputs[index]).val());
                    $(tagetInputs[index]).val(currentVal);
                });
            }
        });
    },
    editModifier() {
        let _this = this;
        $('body').on('click', '.modifier-edit', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/get_modifier',
                data: ({
                    id: $(this).data('id'),
                }),
                success: function(response) {
                    increment = response.increment;
                    $('#modifier_form').html(response.view);
                    $('#modifier-modal').modal('show');
                    _this.modifierSetTypeChange();
                    _this.modifierSetSortChange();
                }
            })
        });
    },
    deleteModifier() {
        $('body').on('click', '.modifier-delete', function (e) {
            e.preventDefault();
            if (confirm('You sure want to delete this?')) {
                $.ajax({
                    type: 'DELETE',
                    url: '/delete_modifier',
                    data: ({
                        id: $(this).data('id'),
                    }),
                    success: function () {
                        $('#modifier_table #table').DataTable().ajax.reload(null, false);
                    }
                });
            }
        });
    },
    deleteModifierInRow() {
        $('body').on('click', '.delete-modifier', function (e) {
            e.preventDefault();
            $('#modifier-id-' + $(this).data('id')).remove();
        });
    },
    getRowModifier() {
        $.ajax({
            type: 'GET',
            url: '/get_row_modifier',
            data: ({
                increment: increment,
                type: $('#modifier-type').val()
            }),
            success: function (response) {
                $('#modifiers').append(response);
                increment++;
            }
        });
    },
    getFormItems() {
        $('body').on('click', '.modifier-add-items', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/modifier_get_form_items',
                data: ({
                    id: $(this).data('id'),
                }),
                success: function (response) {
                    $('#modifier_form').html(response);
                    $('#modifier-modal').modal('show');
                }
            })
        });
    },
}
